export const UserType = {
  HQ: "HQ",
  Dealer: "Dealer"
};

export const UserTypeOptions = [
  { value: UserType.HQ, text: "Internal" },
  { value: UserType.Dealer, text: "External" }
];
